<template>

    <div class="hero">
        <div class="title_notice_line">
            <div class="coeffs_heading container">
                <h1 class="page-title title is-size-2 has-text-weight-bold">Votre référentiel à bien été enregistré</h1>
                <!-- <notifText v-html="$t('modules.refs.formStep4.globalNotice')" /> -->
                <div  class="notification_text is-default">Votre référentiel est bien enregistré, vous pouvez maintenant créer une nouvelle campagne à partir de ce référentiel pour trouver le candidat avec les bonnes compétences pour votre équipe </div>
            </div>
        </div>
        <div class="hero-body team_fit_form_wrapper">
            
            <div class=" bottom-section container">
               
                <div class="has-text-centered">
                    <button class="button  is-info is-rounded is-outlined" @click="goEdit()">
                        Accéder au référentiel
                    </button>

                    <router-link to="/positions/new" >
                        <button class="button  is-info is-rounded is-outlined">{{ $t('modules.positions.index.newPositionButton') }}</button>
                    </router-link>
                </div>

                
            </div>

        </div>
    </div>

</template>

<script>
    export default {
        name: 'TeamFitRefSaved',
        props: ['teamRef'],
        components: {},
        created(){},
        data(){
            return {}
        },
        computed: {
            isFormValid(){
                return  this.teamRef.name != ''
            }
        },
        methods: {
            goEdit(){
                this.$router.push('/refs/' + this.teamRef.id)
            },
        }
    }
</script>

<style lang="scss" scoped>
.team_fit_form_wrapper{
    background: white;
}
</style>
